import { render, staticRenderFns } from "./ShipmentAnalysis.vue?vue&type=template&id=cf304f28&scoped=true"
import script from "./ShipmentAnalysis.vue?vue&type=script&lang=js"
export * from "./ShipmentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ShipmentAnalysis.vue?vue&type=style&index=0&id=cf304f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf304f28",
  null
  
)

export default component.exports